import * as types from '@/store/types.js'
import Page from '@/model/Page'
import {removeResource, activeResource} from '@/store/helpers'

const state = {
  pages: {
    pagination: {},
    data: {}
  },
  activePage: {
    additionals: {},
    languages: {
      hr: {
        additionals: {},
        blocks: []
      },
      en: {
        additionals: {},
        blocks: []
      }
    }
  },
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_PAGES]: state => state.pages,
  [types.ACTIVE_PAGE]: state => state.activePage,
  [types.IS_LOADING_PAGES]: state => state.isLoading
}

// ACTIONS
const actions = {
  [types.GET_ALL_PAGES]: ({ commit }, value) => {
    commit(types.GET_ALL_PAGES, value)
  },
  [types.ADD_PAGE]: ({ commit }, value) => {
    commit(types.ADD_PAGE, value)
  },
  [types.UPDATE_PAGE]: ({ commit }, value) => {
    commit(types.UPDATE_PAGE, value)
  },
  [types.REMOVE_PAGE]: ({ commit }, value) => {
    commit(types.REMOVE_PAGE, value)
  },
  [types.ACTIVE_PAGE]: ({ commit }) => {
    commit(types.ACTIVE_PAGE)
  },
  [types.UPDATE_PAGE_URL]: ({ commit }, value) => {
    commit(types.UPDATE_PAGE_URL, value)
  },
  [types.IS_LOADING_PAGES]: ({ commit }, value) => {
    commit(types.IS_LOADING_PAGES, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_PAGES] (state, value) {
    state.pages = value
  },
  [types.ADD_PAGE]: (state, value) => {
    state.pages.data.unshift(value)
  },
  [types.UPDATE_PAGE]: (state, value) => {
    state.activePage = value
  },
  [types.REMOVE_PAGE]: (state, value) => {
    removeResource(Page, value, state.pages, 'pages.index')
  },
  [types.ACTIVE_PAGE]: (state, value) => {
    state.activePage = activeResource(state.pages.data)
    if (state.activePage.type) {
      state.activePage.type_id = state.activePage.type.id
    }
  },
  [types.UPDATE_PAGE_URL]: (state, value) => {
    state.activePage.languages[value.language].url = value.url
  },
  [types.IS_LOADING_PAGES]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Page.js